export function determineMostOccuringProvider(providers: BikeProvider[]) {
  const providersUnique = [...new Set(providers)]

  const providerCount = providersUnique.map((key: BikeProvider) => ({
    key: key,
    count: providers.filter((provider) => provider === key).length,
  }))

  const providerSorted = providerCount.sort((a, b) => b.count - a.count)

  if (!providerSorted[0]) {
    return getProvider('UNKNOWN')
  }

  const provider = getProvider(providerSorted[0].key)

  return provider
}
